<template>
	<div>
		<a-modal v-show='!ishand' id='sifan' width='55rem' v-model="visible" on-ok="handleOk1" @cancel="handleCancel(0)"
			v-dragModal class='myfus'
			:footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-lisp'>
				<div style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 100%;">
					網上交易系統示範</div>

			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="margin: 1rem;height:30rem">
				<a-row>
					<a-col :span='4'>
						<div v-for='(item,ind) in leftarr' class='leftTitle' @click='handis(item,ind)'
							:style="{backgroundColor:item.s == 1?'#0c8b97':lanis==ind+1 ? 'orange':''
							,color:item.s == 1?'#fff':lanis==ind+1 ? '#fff':''}">
							{{item.a}}
						</div>
					</a-col>
					<a-col :span='20'>
						<div style="text-align: center;" v-if='lanis'>
							{{leftarr[lanis-1].a}}
						</div>
					</a-col>
				</a-row>
			</div>
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: ['openstatic'],
		data() {
			return {
				lanis: '',
				visible: true,
				ishand: false,
				leftarr: [{
					a: '開始使用',
					s: '1',
				}, {
					a: '登入',
					s: '0',
				}, {
					a: '更改密碼',
					s: '0',
				}, {
					a: '登出',
					s: '0',
				}, {
					a: '訂單處理',
					s: '1',
				}, {
					a: '輸入買賣盤',
					s: '0',
				}, {
					a: '程式買賣',
					s: '0',
				}, {
					a: '更改買賣盤',
					s: '0',
				}, {
					a: '取消買賣盤',
					s: '0',
				}, {
					a: '查詢訂單資料',
					s: '0',
				}, {
					a: '當日成交',
					s: '0',
				}, {
					a: '股票/現金結存',
					s: '0',
				}]
			}
		},
		methods: {
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {},
			handis(val,ind) {
				if(val.s==0){
					this.lanis = ind+1
				}
			},
		}
	}
</script>
<style lang='scss' scoped>
	.mark-lisp {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;

		div {
			text-align: center;
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}
</style>
<style lang="scss">
	#sifan {
		.ant-modal-header,
		.ant-modal-body {
			background-color: #fff !important;
		}
		.ant-modal {
			top: 15vh;
		}
		.ant-modal-content{
			border-radius: 10px;
		}
		.ant-modal-close-x {
			.anticon svg {
				color: #5cb1b9;
				position: relative;
				top: .8rem
			}
		}

		.leftTitle {
			text-align: center;
			font-size: 1rem;
			padding: .46rem 0;
			background-color: #f5f5f5;
		}

		.leftTitle:hover {
			background-color: orange;
			color: #fff;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}
	}
</style>
